<template>

  <div class="card shadow"
       :class="type === 'dark' ? 'bg-default': ''">
    <div class="card-header border-0"
         :class="type === 'dark' ? 'bg-transparent': ''">
      <div class="row align-items-center">
        <div class="col">
          <h3 class="mb-0" :class="type === 'dark' ? 'text-white': ''">
            {{title}}
          </h3>
          <span class="mb-0" :class="type === 'dark' ? 'text-white': ''">
            {{tablePageData.length}} resultados
          </span>
        </div>
      </div>
    </div>
    <base-input style="padding-left: 2rem; padding-right: 2rem" placeholder="Buscar" v-model="search"> </base-input>
    <div class="table-responsive">
      <base-table class="table align-items-center table-flush"
                  :class="type === 'dark' ? 'table-dark': ''"
                  :thead-classes="type === 'dark' ? 'thead-dark': 'thead-light'"
                  tbody-classes="list"
                  :data="tablePageData">
        <template slot="columns">
          <th>ID Cliente</th>
          <th>Nombre</th>
          <th>Creado el</th>
          <th>Creado por</th>
          <th>Estaciones de servicio</th>
        </template>

        <template slot-scope="{row}">
          <th>
           {{row.clientId}}
          </th>
          <th scope="row">
            <div class="media align-items-center">
              <div class="media-body">
                <span class="name mb-0 text-sm">{{row.razonSocial}}</span>
              </div>
            </div>
          </th>
          <td class="align-items-center">
            {{getReadableDate(row.createdOn)}}
          </td>
          <td class="align-items-center">
            {{row.createdBy}}
          </td>
          <td class="text-center">
            {{row.estaciones}}
          </td>
        </template>
      </base-table>
    </div>
  </div>
</template>
<script>
import moment from "moment";
  export default {
    name: 'clients-table',
    props: {
      type: {
        type: String
      },
      title: String,
      tableData: Array
    },
    computed: {
      tablePageData: function () {
        let search = this.search.toUpperCase();
        return this.tableData.filter((item) => {
          let containsClientId = item.clientId.toUpperCase().includes(search);
          let containsRazonSocial = item.razonSocial.toUpperCase().includes(search);
          let containsCreatedBy = item.createdBy.toUpperCase().includes(search);
          return containsClientId || containsRazonSocial || containsCreatedBy;
        })
      }
    },
    methods:{
      getReadableDate(timestamp){
        moment.locale('es');
        let time = moment(timestamp, 'x')
        return time.format('ll');
      }
    },
    data() {
      return {
        search: ''
      }
    }
  }
</script>
<style>
</style>